import { render } from "./LocationPageCMS.vue?vue&type=template&id=51f322c8"
import script from "../js/location-page-cms.js?vue&type=script&lang=js"
export * from "../js/location-page-cms.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__